var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5963 24.5351H8.85195L33.7241 9.22916L58.5963 24.5351Z",
    stroke: "black",
    strokeWidth: 1.24198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.986 25.1562V45.9764",
    stroke: "black",
    strokeWidth: 1.24198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.478 25.1562V45.9764",
    stroke: "black",
    strokeWidth: 1.24198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9701 25.1562V45.9764",
    stroke: "black",
    strokeWidth: 1.24198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4622 25.1562V45.9764",
    stroke: "black",
    strokeWidth: 1.24198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73987 45.9766H58.7081",
    stroke: "black",
    strokeWidth: 1.24198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57593 54.3037H62.8722",
    stroke: "black",
    strokeWidth: 1.24198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5099,
    cy: 59.7298,
    r: 14.5179,
    fill: "#EF2C5A",
    stroke: "black",
    strokeWidth: 1.26243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6273 66.0417C59.6273 66.5646 59.2034 66.9885 58.6805 66.9885C58.1576 66.9885 57.7337 66.5646 57.7337 66.0417V60.8514H52.5431C52.0202 60.8514 51.5963 60.4275 51.5963 59.9046C51.5963 59.3816 52.0202 58.9577 52.5431 58.9577H57.7337V53.7671C57.7337 53.2442 58.1576 52.8203 58.6805 52.8203C59.2034 52.8203 59.6273 53.2442 59.6273 53.7671V58.9577H64.8177C65.3406 58.9577 65.7645 59.3816 65.7645 59.9046C65.7645 60.4275 65.3406 60.8514 64.8177 60.8514H59.6273V66.0417Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.6244,
    height: 66.6244,
    fill: "white",
    transform: "translate(0.411865 0.171875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAccount);
export default __webpack_public_path__ + "static/media/emptyAccount.36464bd39daed5c55989cfdbfe766f75.svg";
export { ForwardRef as ReactComponent };